@if (directionList) {
  <p-select
    appendTo="body"
    (onChange)="onDirectionChange($event)"
    [options]="directionList"
    [(ngModel)]="direction"
    [placeholder]="direction"
    [filter]="true"
    filterBy="label, value"
  >
  </p-select>
}
